import i18n from "locale/config"
import _ from "lodash"

// Actions
const CHANGE_LANGUAGE = "language/CHANGE_LANGUAGE"

// Action creators
export const changeLanguage = (lang: any) => {
  return (dispatch: any) => {
    dispatch({ type: CHANGE_LANGUAGE, language: lang })
    localStorage.setItem("i18nLocalStorageKey", lang.value)
    i18n.changeLanguage(lang.value)
  }
}

// Language options
export const langOptions = [
  { value: "en", label: "English" },
  { value: "fr", label: "Français" },
  { value: "de", label: "Deutsch" },
  { value: "pt", label: "Português" },
  { value: "es", label: "Español" }
]
const langOptionsByValue = _.keyBy(langOptions, "value")

// selectors

export const getLanguage = (state: any) => state.language.language

// Initial State
export const initialState = () => {
  const lsLangValue = localStorage.getItem("i18nLocalStorageKey")
  return {
    language: langOptions[0].value
  }
}

// Reducer
export default function LanguageReducer(
  state = initialState(),
  action: any = {}
) {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.language
      }
    default:
      return state
  }
}
